import { render, staticRenderFns } from "./BreakInfinityButton.vue?vue&type=template&id=a8405908&scoped=true"
import script from "./BreakInfinityButton.vue?vue&type=script&lang=js"
export * from "./BreakInfinityButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8405908",
  null
  
)

export default component.exports